import React from "react"
import { Paper } from "material-ui"
import strings from "../../localization/strings"
import HierarchyDetails from "./hierarchy-details/HierarchyDetails"
import HierarchyChildren from "./hierarchy-children/HierarchyChildren"
import HierarchyDevices from "./hierarchy-devices/HierarchyDevices"
import HierarchyEmployees from "./hierarchy-employees/HierarchyEmployees"
import HierarchyPositions from "./hierarchy-positions/HierarchyPositions"
import HierarchyLocation from "./hierarchy-location/HierarchyLocation"
import HierarchyRecords from "./hierarchy-records/HierarchyRecords"
import HierarchyUsers from "./hierarchy-users/HierarchyUsers"
import HierarchySettings from "../../components/hierarchy_settings/HierarchySettings"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import _ from "lodash"
import autobind from "class-autobind"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import * as  appStateActions from "../../actions/AppStateActions"
import * as  hierarchyNavItemsHelper from "../../helpers/hierarchyNavItemsHelper"
import * as  permissionHelper from "../../helpers/permissionHelper"
import { IHierarchyItem, IHierarchyItemForAccountLevel } from "../../models"
import hierarchySettingsStore from "../../stores/HierarchySettingsStore"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"
interface IProps {
    params: { subpage: string }
}
interface IState {
    currentHierarchyItem: IHierarchyItemForAccountLevel | IHierarchyItem
}

export default class Hierarchy extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            currentHierarchyItem: null,
        }
        autobind(this)
    }

    componentDidMount() {
        document.title = `${strings.Hierarchy} | ${strings.Findd_Grandd_Central}`
        HierarchySettingsStore.on("global_change", this.onChangeLevel)
        this.onChangeLevel()
    }

    componentWillUnmount() {
        HierarchySettingsStore.removeListener("global_change", this.onChangeLevel)
    }

    onChangeLevel() {
        const hierarchyPathToRoot = hierarchyHelper.getHierarchyPathToRoot(hierarchySettingsStore.getGlobalLevelItemFilterId())
        const hierarchyItem = hierarchyPathToRoot.length === 1 ? hierarchyPathToRoot[0] : hierarchyPathToRoot[hierarchyPathToRoot.length - 1].hierarchyItem
        !_.isEqual(hierarchyItem, this.state.currentHierarchyItem) &&
            this.setState({ currentHierarchyItem: hierarchyItem },
                () => this.getShowNavItems()
            )
    }

    getShowNavItems() {
        const isAccountLevel = HierarchySettingsStore.getGlobalLevelItemFilterId() ? false : true
        const showNavItems = hierarchyNavItemsHelper.getHierarchySubMenuItems(
            isAccountLevel,
            AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForAccountUserUnlessAssigned,
            AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForEmployeeUnlessAssigned,
            this.props.params.subpage,
            true
        )
        AppStateStore.getHierarchyNavItems().toString().localeCompare(showNavItems.toString()) !== 0 &&
            appStateActions.setHierarchyNavItems(showNavItems)
    }

    render() {
        const { currentHierarchyItem } = this.state
        if (!currentHierarchyItem) return null

        let contentPaper = null
        let pageTitle = ""

        const isAccountLevel = HierarchySettingsStore.getGlobalLevelItemFilterId() ? false : true

        const levels = hierarchyHelper.getChildHierarchyItems(hierarchySettingsStore.getGlobalLevelItemFilterId())
        const definitions = AccountStore.getCurrentAccount().HierarchyDefinitions
        const childLevel = isAccountLevel ?
            definitions[0] :
            hierarchyHelper.getHierarchyDefinitionByLevel(
                definitions.find(item =>
                    item.Id === (currentHierarchyItem as IHierarchyItem).HierarchyDefinitionId
                ).Level + 1
            )
        const canSelectedHaveChildren = isAccountLevel ?
            true :
            childLevel && hierarchyHelper.getHierarchyDefinitionByLevel(childLevel.Level) ?
                true :
                false
        const readonly = !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditHierarchy)
        switch (this.props.params.subpage) {
            case "details":
                contentPaper = <HierarchyDetails hierarchyItem={currentHierarchyItem} readonly={readonly} />
                pageTitle = isAccountLevel ? strings.Account_Details : strings.Hierarchy_Details
                break
            case "children":
                contentPaper = <HierarchyChildren hierarchyItem={currentHierarchyItem} readonly={readonly} childHierarchyItemsForGlobalFilter={levels} childLevel={childLevel} canSelectedHaveChildren={canSelectedHaveChildren} />
                pageTitle = strings.Hierarchy_Children
                break
            case "users":
                contentPaper = <HierarchyUsers hierarchyItem={currentHierarchyItem} readonly={readonly} />
                pageTitle = strings.Hierarchy_Users
                break
            case "employees":
                contentPaper = <HierarchyEmployees hierarchyItem={currentHierarchyItem as IHierarchyItem} readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.EditEmployees)} />
                pageTitle = strings.Hierarchy_Employees
                break
            case "positions":
                contentPaper = <HierarchyPositions hierarchyItem={currentHierarchyItem as IHierarchyItem} readonly={readonly} />
                pageTitle = checkPositionFieldAvailable('plural') ? `Hierachy ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel}`: strings.Hierarchy_Positions_Table_Title
                break
            case "location":
                contentPaper = <HierarchyLocation hierarchyItem={currentHierarchyItem as IHierarchyItem} readonly={readonly} />
                pageTitle = strings.Hierarchy_Location
                break
            case "records":
                contentPaper = <HierarchyRecords hierarchyItem={currentHierarchyItem as IHierarchyItem} readonly={readonly} />
                pageTitle = ""
                break
            case "devices":
                contentPaper = <HierarchyDevices hierarchyItem={currentHierarchyItem as IHierarchyItem} />
                pageTitle = strings.Hierarchy_Devices
                break
            case "settings":
                contentPaper = <HierarchySettings hierarchyJobItem={currentHierarchyItem} readonly={readonly} />
                pageTitle = strings.Hierarchy_Settings
                break
        }
        const content = this.props.params.subpage === "settings" || this.props.params.subpage === "location" || this.props.params.subpage === "devices" ? contentPaper : <Paper zDepth={0}>{contentPaper}</Paper>
        return (
            <div className="page-container Hierarchy">
                <div className="page-container-parent">
                    <Paper zDepth={1} className="page-paper">
                        <div style={{ padding: 20 }}>
                            <div
                                className="pageHeading"
                                style={{ marginBottom: "15px", marginTop: "5px", marginLeft: "10px" }}
                            >
                                {pageTitle}
                            </div>
                            {content}
                        </div>
                    </Paper>
                </div>
            </div>
        )
    }
}
